import jwt_decode from "jwt-decode";

(() => {
  const urlParams = new URLSearchParams(window.location.search);
  const preview = urlParams.get("preview");

  if (window.token) {
    for (let tkey in window.token)
      if (window.token[tkey])
        window.token[tkey] = window.token[tkey].split("").reverse().join("");
    let tk = [window.token["f"], window.token["m"], window.token["l"]].join(
      "."
    );
    let decodedTK = jwt_decode(tk);
    window.env = decodedTK;
  }
  if (!window.env) window.env = {};
  for (const envKey in process.env) {
    // Preserve the explicit runtime false for this optional feature.
    if (envKey === "REACT_APP_SHOW_LOTTO_DREAM"
      ? window.env[envKey] === undefined || window.env[envKey] === null
      : !window.env[envKey]) window.env[envKey] = process.env[envKey];
  }
  if (preview == "true") {
    let preview_token = {
      f: urlParams.get("f"),
      m: urlParams.get("m"),
      l: urlParams.get("l"),
    };
    for (let tkey in preview_token)
      if (preview_token[tkey])
        preview_token[tkey] = preview_token[tkey].split("").reverse().join("");
    let tk = [preview_token["f"], preview_token["m"], preview_token["l"]].join(
      "."
    );
    let decodedPTK = jwt_decode(tk);
    Object.assign(window.env, decodedPTK);
  }
  // window.env.PREFIX = window.env.PREFIX || "TEAY";
  if(window.env.lang && !localStorage.getItem("lang")) localStorage.setItem("lang", window.env.lang);
  window.env.modal_bg = `
  .rank-modal-bg>div>.modal-content{
    background: ${window.env.REACT_APP_BG_MODAL_CONTENT};
    border: ${window.env.REACT_APP_BORDER_MODAL_CONTENT};
  `;
})();
